import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Hata olunca state'i güncelle
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Hatayı console'a logla (production'da da görmek için)
    console.error('💥 Error Boundary yakaladı:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Hata UI'ı
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
          color: 'white',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          padding: '20px'
        }}>
          {/* Hata İkonu */}
          <div style={{
            fontSize: '72px',
            marginBottom: '24px',
            animation: 'shake 0.5s ease-in-out'
          }}>
            ⚠️
          </div>

          {/* Başlık */}
          <h1 style={{
            fontSize: '32px',
            fontWeight: 'bold',
            marginBottom: '16px',
            textAlign: 'center'
          }}>
            Bir Şeyler Ters Gitti
          </h1>

          {/* Açıklama */}
          <p style={{
            fontSize: '18px',
            color: '#94a3b8',
            marginBottom: '32px',
            textAlign: 'center',
            maxWidth: '500px',
            lineHeight: '1.6'
          }}>
            Üzgünüz, beklenmeyen bir hata oluştu. Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin.
          </p>

          {/* Butonlar */}
          <div style={{ display: 'flex', gap: '16px' }}>
            {/* Yenile Butonu */}
            <button
              onClick={() => window.location.reload()}
              style={{
                background: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                padding: '14px 32px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 4px 16px rgba(139, 92, 246, 0.4)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 24px rgba(139, 92, 246, 0.6)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 16px rgba(139, 92, 246, 0.4)';
              }}
            >
              🔄 Sayfayı Yenile
            </button>

            {/* Ana Sayfaya Dön */}
            <button
              onClick={() => window.location.href = '/'}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                color: 'white',
                border: '2px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                padding: '14px 32px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
              }}
            >
              🏠 Ana Sayfa
            </button>
          </div>

          {/* Hata Detayı (Development için) */}
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{
              marginTop: '40px',
              padding: '20px',
              background: 'rgba(0, 0, 0, 0.3)',
              borderRadius: '8px',
              maxWidth: '800px',
              width: '100%',
              fontSize: '14px',
              color: '#ef4444',
              fontFamily: 'monospace'
            }}>
              <summary style={{ cursor: 'pointer', marginBottom: '12px', fontWeight: 'bold' }}>
                🔍 Hata Detayı (Sadece Development)
              </summary>
              <pre style={{ 
                whiteSpace: 'pre-wrap', 
                wordBreak: 'break-word',
                margin: 0 
              }}>
                {this.state.error.toString()}
              </pre>
            </details>
          )}

          {/* CSS Animasyon */}
          <style>
            {`
              @keyframes shake {
                0%, 100% { transform: translateX(0); }
                25% { transform: translateX(-10px) rotate(-5deg); }
                75% { transform: translateX(10px) rotate(5deg); }
              }
            `}
          </style>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

